var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 39.771h1.875V26.23h-1.875A1.875 1.875 0 0 1 15 24.354v-4.479c0-1.036.84-1.875 1.875-1.875h10.5c1.036 0 1.875.84 1.875 1.875v19.896h1.875c1.036 0 1.875.84 1.875 1.875v4.479C33 47.161 32.16 48 31.125 48h-14.25A1.875 1.875 0 0 1 15 46.125v-4.479c0-1.035.84-1.875 1.875-1.875zM24 0a6.75 6.75 0 1 0 0 13.5A6.75 6.75 0 0 0 24 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c0d6070832edbd03837d5604815c855d.svg";
export { ForwardRef as ReactComponent };